import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Button, ModalBody, ModalFooter, Row, Col } from 'react-bootstrap';
import { translationAction } from '../../../store/external/translation-reducer/translation.reducer';
import { loadUserSessionStorage } from '../../../utils/helpers.utils';
import { LOGIN_STATUS as loginStat } from '../../../utils/constant.utils';
import Loader from '../../../../img/icon-circuit-loader.gif';
import './modal-popover.component.css';

class UserLanguageModal extends Component {

    componentDidMount() {
        const { setLanguage } = this.props;
        if (loadUserSessionStorage() != null && loadUserSessionStorage().Employee.LanguageLocale != null && loadUserSessionStorage().Employee.LanguageLocale != '') {
            setLanguage(loadUserSessionStorage().Employee.LanguageLocale);
        }
    }

    render() {
        const { isLangConfirmModal, setLangConfodalOpen, setLanguage, languageLoading } = this.props;
        return (
            <div>
                <Modal className="user-lang-modal custom-column-modal-container center" show={isLangConfirmModal} dialogClassName="center modal-lg">
                    <Modal.Header>
                        <Modal.Title>
                            <span>Preferred Language</span>
                        </Modal.Title>
                    </Modal.Header>
                    <ModalBody>
                        <Row className="user-lang-row">
                            <Col xs={12} md={12} lg={12}>
                                <div className="user-lang-body">
                                    Translations of pages on ATEM Application is performed by Google Translate. Google Translate is a free online language translation service that can translate text into different languages.
                                    <br /><br />
                                    Computerized translations from one language to another is a literal translation that may not represent the accurate content.
                                    Whenever Google Translate generates a translation, it uses references from various documents to literally translate the words into the most common used term, 
                                    which may not be the way the content is typically spoken or written in a chosen language. By detecting patterns in documents that have already been translated by human translators, Google Translate makes a best guess as to what a similar translation could be. 
                                    The translation should not be considered exact and in some cases may include incorrect or offensive language.
                                    <br /><br />
                                    If you have any questions about Google Translate, please click the following link:
                                    <a href="http://translate.google.com/about/intl/en_ALL/" target="_blank"> http://translate.google.com/about/intl/en_ALL/</a>
                                    <br /><br />
                                    If you want to proceed with the translation please select "Continue", otherwise “Discard”.
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Row className="user-lang-row">
                            <Col xs={12} md={12} lg={12}>
                                <div className={sessionStorage.getItem('logInStatus') == loginStat.internal ? 'user-lang-buttons-internal' : 'user-lang-buttons'}>
                                    <Button
                                        id="discard-btn"
                                        onClick={e => { setLangConfodalOpen(false, '') }}>
                                        Discard
                                    </Button>
                                    
                                    <Button
                                        id="confirm-btn"
                                        onClick={e => { setLanguage() }}>
                                        Confirm
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>
                {(languageLoading) ? <div className="toast-backdrop language-loader-div"><img src={Loader} /></div> : ''}
            </div>
        );
    }
}

export default connect(
    state => state.translation,
    dispatch => bindActionCreators(translationAction, dispatch)
)(UserLanguageModal);